const AUTH_TOKEN_STORAGE_KEY = "gwAuthToken";

function getStoredToken(): string | null {
  return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
}

// Google login redirects back with #auth_token=<session JWT> in the URL hash —
// capture it once on page load, then scrub it from the visible URL.
function captureAuthTokenFromHash(): void {
  const match = window.location.hash.match(/auth_token=([^&]+)/);
  if (!match) return;
  localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, decodeURIComponent(match[1]!));
  history.replaceState(null, "", window.location.pathname + window.location.search);
}
captureAuthTokenFromHash();

export function isLoggedIn(): boolean {
  return getStoredToken() !== null;
}

export function logout(): void {
  localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
  window.location.href = "/index.html";
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const key = getStoredToken();
  const headers: Record<string, string> = { "content-type": "application/json", ...(init?.headers as Record<string, string> | undefined) };
  if (key) headers.Authorization = `Bearer ${key}`;

  const response = await fetch(path, { ...init, headers });

  if (response.status === 401) {
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = `/login.html?returnTo=${returnTo}`;
    throw new Error("unauthorized");
  }

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error ?? `request failed: ${response.status}`);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}
